import ScalarVirtualText_default from "./ScalarVirtualText.vue.js";
export { ScalarVirtualText_default as ScalarVirtualText };
